import * as React from 'react';
import { useState, useContext } from 'react';
import { Box, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useTranslation } from 'react-i18next';
import ReportDialog from './ReportDialog';
import { ReportContext } from '../store/reportContext';

interface StorageColumnProps {
  selectedUserId: number | null;
  selectedSiteId: number | null;
  reports: VptReport[];
}

const StorageColumn: React.FC<StorageColumnProps> = ({
  selectedSiteId,
  reports,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { deleteReport } = useContext(ReportContext);
  const [selectedReport, setSelectedReport] = useState<VptReport | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleReportClick = (report: VptReport) => {
    setSelectedReport(report);
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
    setSelectedReport(null);
  };

  const handleDeleteReport = async (id: number) => {
    if (window.confirm('Are you sure you want to delete this report?')) {
      await deleteReport(id);
      handleCloseDialog();
    }
  };

  const handleDownloadReport = (report: VptReport) => {
    console.log('Download report clicked', report);
  };

  const handlePrintReport = (report: VptReport) => {
    console.log('Print report clicked', report);
  };

  return (
    <Grid size={{ xs: 3 }} sx={{ borderLeft: theme.palette.border, p: 1, display: 'flex', flexDirection: 'column' }}>
      {!selectedSiteId ? (
        <Box
          sx={{
            alignItems: 'center',
            ...theme.typography.placeHolderFont,
          }}
        >
          {t('storages:t.selectStorage')}
        </Box>
      ) : (
        reports.map((report) => (
          <Box
            key={report.id}
            onClick={() => handleReportClick(report)}
            sx={{
              display: 'flex',
              height: '30px',
              minHeight: '30px',
              paddingLeft: '12px',
              alignItems: 'center',
              gap: '10px',
              alignSelf: 'stretch',
              ...theme.typography.usersFontTitle,
              cursor: 'pointer',
              '&:hover': {
                textDecoration: 'underline',
                color: 'green',
              },
              mb: 1,
            }}
          >
            {report.storageName}
          </Box>
        ))
      )}
      <ReportDialog
        open={isDialogOpen}
        onClose={handleCloseDialog}
        onDelete={handleDeleteReport}
        onDownload={handleDownloadReport}
        onPrint={handlePrintReport}
        report={selectedReport}
      />
    </Grid>
  );
};

export default StorageColumn;
